import { Component } from '@angular/core';
import { AppFlowService } from '../../services/app-flow.service';
import { EnvConfig } from '../../models/env-config';
import { SessionStorageService } from '../../services/session-storage.service';

@Component({
  selector: 'app-biometry-page',
  templateUrl: './biometry-page.component.html',
  styleUrls: ['./biometry-page.component.scss'],
})
export class BiometryPageComponent {
  messageBiometria: string;
  envConfig: EnvConfig;

  constructor(
    private appFlowService: AppFlowService,
    private sessionStorageService: SessionStorageService
  ) {
    this.envConfig = sessionStorageService.getEnvConfig();

    this.messageBiometria = this.envConfig['message.biometria.body'] || '';
  }

  nextStep(): void {
    this.appFlowService.nextStep(true);
  }
}
